import type { SanctionView } from '@wyn/contracts';
import { UI } from '../icons/ui-icons.ts';
import { rt } from '../lib/runtime.ts';
import { STEWARDS_EMAIL } from '../lib/stewards.ts';
import { LegalLinks, Masthead } from './Layout.tsx';
import { PageTitle } from './ui.tsx';

const when = (at: number) => new Date(at).toLocaleString('en-GB', { timeZone: 'UTC', day: 'numeric', month: 'long', year: 'numeric', hour: '2-digit', minute: '2-digit' });

/** "until 5 October 2026, 14:00 UTC", or "for good". */
export const sanctionUntil = (s: SanctionView) => (s.until === null ? 'for good' : `until ${when(s.until)} UTC`);

/** What a banished player sees in place of the game: why, until when, and how to appeal. */
export function Banished({ sanction }: { sanction: SanctionView }) {
  return (
    <div className="mx-auto flex min-h-dvh max-w-2xl flex-col px-4">
      <header className="border-b border-rule py-3"><Masthead /></header>
      <main className="panel my-10 space-y-4">
        <PageTitle icon={UI.locked}>Banished from the realm</PageTitle>
        <p>The stewards have banished you {sanctionUntil(sanction)}.</p>
        <blockquote className="border-l-2 border-blood pl-3 text-ink-dim">{sanction.reason}</blockquote>
        <p className="text-sm text-ink-dim">
          If you think this is wrong, write to <a className="text-gilt underline" href={`mailto:${STEWARDS_EMAIL}`}>{STEWARDS_EMAIL}</a> with your character’s name. A steward will read it.
        </p>
        <button type="button" className="btn-quiet" onClick={() => rt().auth.signOut()}>
          Sign out
        </button>
      </main>
      <footer className="flex text-xs text-ink-faint"><LegalLinks /></footer>
    </div>
  );
}
